import React from 'react'
import {
  withTooltip,
  AutoApprovedFilledIcon,
  CircleFilledIcon,
  CirclePartialFilledIcon,
  OverdueFilledIcon,
} from '@modifi/ui'
import {alert, landGreen} from '@modifi/colors'
import {useTranslation} from '@modifi/plugin-i18n'
import {TaskStatus} from '@modifi/enums'

const DaysLeftIcon = withTooltip(CirclePartialFilledIcon) as React.ComponentType<any>
const TodayIcon = withTooltip(CircleFilledIcon) as React.ComponentType<any>
const OverdueIcon = withTooltip(OverdueFilledIcon) as React.ComponentType<any>
const ResolvedIcon = withTooltip(AutoApprovedFilledIcon) as React.ComponentType<any>

type DueDateIconProps = {
  taskStatus: string
  dueDateValue: string
}

const DueDateIcon: React.FC<DueDateIconProps> = ({taskStatus, dueDateValue}) => {
  const {t} = useTranslation('kartavya')

  const daysDiff = Math.floor(
    (new Date().getTime() - new Date(dueDateValue).getTime()) / (1000 * 60 * 60 * 24)
  )

  if (taskStatus === TaskStatus.RESOLVED) {
    return (
      <ResolvedIcon
        tooltipContent={t('tasks.due-date-status.resolved')}
        tooltipTheme="dark"
        tooltipPlacement="top"
        color={landGreen}
      />
    )
  }
  if (daysDiff > 0) {
    return (
      <OverdueIcon
        tooltipContent={t('tasks.due-date-status.overdue', {daysDiff})}
        tooltipTheme="dark"
        tooltipPlacement="top"
        color={alert}
      />
    )
  }
  if (daysDiff === 0) {
    return (
      <TodayIcon
        tooltipContent={t('tasks.due-date-status.today')}
        tooltipTheme="dark"
        tooltipPlacement="top"
      />
    )
  }
  return (
    <DaysLeftIcon
      tooltipContent={t('tasks.due-date-status.days-left', {daysDiff: -daysDiff})}
      tooltipTheme="dark"
      tooltipPlacement="top"
    />
  )
}

export default DueDateIcon
